<template>
  <div>
    <div class="float_share fadeInRight" style="margin-bottom: 100px;">
      <h6>
        <a href="//www.facebook.com/dicicilaja" target="_blank">
          <i class="fa fa-facebook facebook"></i>
        </a>
        <br/>
        <a href="//www.instagram.com/dicicilaja" target="_blank">
          <i class="fa fa-instagram twitter"></i>
        </a>
      </h6>
    </div>

    <footer class="bg-orange">
      <div class="container">
        <div class="row p-t-50 p-b-50">
          <div class="col-sm-3">
            <h5 class="uppercase color-white semibold m-b-15">Tentang Kami</h5>
            <ul>
              <li>
                <router-link :to="{ name: 'profile' }">Sekilas</router-link>
              </li>
              <li>
                <router-link :to="{ name: 'profile' }">Visi Misi</router-link>
              </li>
              <li>
                <router-link :to="{ name: 'profile' }">Kelebihan</router-link>
              </li>
              <li>
                <router-link :to="{ name: 'policy' }">Kebijakan Privasi</router-link>
              </li>
            </ul>
          </div>
          <div class="col-sm-3">
            <h5 class="uppercase color-white semibold m-b-15">Jaringan</h5>
            <ul>
              <li>
                <router-link :to="{ name: 'profile' }">Jaringan Layanan</router-link>
              </li>
              <!-- <li><router-link :to="{ name: 'status_pengajuan' }">Cek Status Pengajuan</router-link></li> -->
              <li>
                <router-link :to="{ name: 'kantor_cabang' }">Lokasi Kantor Cabang</router-link>
              </li>
            </ul>
          </div>
          <div class="col-sm-3">
            <h5 class="uppercase color-white semibold m-b-15">Temukan Kami</h5>
            <div class="semibold color-white m-b-25">
              <!-- <h6 class="semibold">
                        Email : <br>
                        admin@dicicilaja.com <br><br>
              </h6>-->
              <a href="//www.facebook.com/dicicilaja" target="_blank">
                <i
                  class="fa fa-facebook color-white text-center"
                  style="width: 30px; font-size: 20px"
                ></i>
              </a>
              <a href="//www.instagram.com/dicicilaja" target="_blank">
                <i
                  class="fa fa-instagram color-white text-center"
                  style="width: 30px; font-size: 20px"
                ></i>
              </a>
            </div>
          </div>
          <div class="col-sm-3">
            <h5 class="uppercase color-white semibold m-b-15">Hubungi Kami</h5>
            <img src="../../assets/images/logo-white.png" alt="Logo" class="h-65"/>
            <br/>
            <div class="semibold color-white">
              <span>0811 146 5005 (Hotline)</span>
            </div>
          </div>
        </div>

        <div class="row text-center text-white p-t-10 p-b-10">
          <div class="col-sm-12">
            <h6>Oleh :
              <img src="../../assets/images/logo_adira_finance_bg_kuning.png"
                   alt="Oleh: Adira Finance" class="adira-logo"/>
            </h6>
          </div>
          <div class="col-sm-12">
            <h6>
              PT Adira Dinamika Multi Finance Tbk berizin dan diawasi oleh Otoritas Jasa Keuangan
            </h6>
          </div>
        </div>
      </div>
      <div class="bg-blue p-t-20 p-b-20 text-center color-white uppercase">
        PT ADIRA DINAMIKA MULTI FINANCE TBK &copy; {{ new Date().getFullYear() }}
      </div>
    </footer>
    <!-- class="back_to_top to_top_active" -->
    <div id="mySidenav" class="sidenav">
      <a
        v-if="getAxiDetail.no_hp && axiId"
        :href="sanitizeUrl_1"
        id="hotline"
        target="_blank"
        rel="noopener"
      >
        Hotline {{ getAxiDetail.no_hp ? getAxiDetail.no_hp.replace("62", "0") : "08111465005" }}
        <i class="fa fa-whatsapp hotline-icon"></i>
      </a>

      <a
        v-else-if="!getAxiDetail.no_hp && axiId"
        :href="sanitizeUrl_2"
        id="hotline"
        target="_blank"
        rel="noopener"
      >
        Hotline {{ getAxiDetail.no_hp ? getAxiDetail.no_hp.replace("62", "0") : "08111465005" }}
        <i class="fa fa-whatsapp hotline-icon"></i>
      </a>
      <!-- <a v-else href="http://wa.me/628111465005" id="hotline" target="_blank"> -->
      <a v-else :href="sanitizeUrl_3" id="hotline" target="_blank" rel="noopener">
        Hotline 0811 146 5005
        <i class="fa fa-whatsapp hotline-icon"></i>
      </a>
    </div>
    <div class="img-hotline">
      <img src="../../assets/images/hotline.png" alt="Hot Line"/>
    </div>

    <!-- <div class="call-center">
      <a href="http://wa.me/628111465005" target="_blank">
        <span>
          <i class="fa fa-phone"></i>
        </span>
      </a>
    </div> -->
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

// using sanitize plugin for securing
var sanitizeUrl = require("@braintree/sanitize-url").sanitizeUrl;

export default {
  data() {
    return {
      profileId: "",
      // link for getAxiDetail.no_hp && axiId
      sanitizeUrl_1: sanitizeUrl("https://http://wa.me/${this.getAxiDetail.no_hp}?text=Semangat%20Pagi%20AXI%2C%20saya%20ingin%20mengajukan%20pertanyaan%20terkait%20Dicicilaja.com%2C%20dapatkah%20saya%20bertanya%20mengenai%20Dana%20Multiguna/Keagenan%20AXI%3F"),
      // link for !getAxiDetail.no_hp && axiId
      sanitizeUrl_2: sanitizeUrl("https://wa.me/628111465005?text=Semangat%20Pagi%2C%20saya%20mengunjungi%20web%20dicicilaja.com/${axiId}%20dan%20ingin%20mengajukan%20pertanyaan%20dapatkah%20membantu%20saya%3F%20Terima%20kasih."),
      // linkWA using https, replace with SSL
      // linkWA: "http://wa.me/628111465005",
      // linkWA for condition else (condition 3)
      linkWA: "https://wa.me/628111465005",
      sanitizeUrl_3: sanitizeUrl("https://wa.me/628111465005")

    };
  },
  computed: {
    ...mapGetters({
      getAxiDetail: "axi/getAxiDetail",
      getAxiId: "auth/getAxiId",
      getUser: "auth/getUser"
    }),
    axiId() {
      return this.$route.params.axi_id;
    }
  },
  methods: {
    ...mapActions({
      getAxiDetailList: "axi/getAxiDetailList",
      checkAxiIdReplika: "order/checkAxiIdReplika"
    })
  }
};
</script>
<style>
.img-hotline {
  bottom: 0;
  opacity: 1;
  position: fixed;
  display: table;
  height: 80px;
  text-align: right;
  z-index: 9999999999;
  right: 0;
}

#mySidenav a {
  /* display: none; */
  position: fixed;
  left: -240px;
  transition: 0.3s;
  padding: 15px;
  width: 290px;
  text-decoration: none;
  font-size: 20px;
  color: white;
  border-radius: 0 8px 8px 0;
  text-align: right;
}

.hotline-icon {
  font-size: 30px !important;
}

#mySidenav a:hover {
  left: 0;
}

#hotline {
  bottom: 100px;
  background-color: #25d366;
  z-index: 1;
}
.adira-logo {
  height: 48px;      /* sesuaikan dengan desain */
  width: auto;
  object-fit: contain;
  display: inline-block;
}
@media (max-width: 576px) {
  .adira-logo {
    height: 32px;
  }
}

</style>
